var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21901",
    "data-name": "Group 21901",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.085,
    height: 11.999,
    viewBox: "0 0 15.085 11.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5221",
    "data-name": "Rectangle 5221",
    width: 15.085,
    height: 11.999,
    fill: "#2bc7c9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19946",
    "data-name": "Group 19946",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30882",
    "data-name": "Path 30882",
    d: "M7.594,12Q4.6,12,1.613,12C.477,12,0,11.53,0,10.407Q0,6.895,0,3.383C0,2.217.47,1.758,1.636,1.753c.768,0,1.538.02,2.3-.017a.866.866,0,0,0,.515-.341,2.27,2.27,0,0,0,.27-.6A1.167,1.167,0,0,1,5.868.012C6.984,0,8.1-.005,9.216.008a1.148,1.148,0,0,1,1.173.9,1.041,1.041,0,0,0,1.3.862,14.224,14.224,0,0,1,1.974-.012,1.307,1.307,0,0,1,1.408,1.409q.022,3.7,0,7.408A1.313,1.313,0,0,1,13.576,12c-1.994.007-3.988,0-5.981,0M7.5,10.941A4.061,4.061,0,1,0,3.478,6.816,4.07,4.07,0,0,0,7.5,10.941M1.988,3.033c-.377-.016-.807-.094-.794.547.011.56.383.525.756.521s.777.073.781-.542c0-.57-.331-.555-.743-.526",
    transform: "translate(0 0)",
    fill: "#2bc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30883",
    "data-name": "Path 30883",
    d: "M46.539,37.815a2.728,2.728,0,1,1-2.706,2.748,2.751,2.751,0,0,1,2.706-2.748",
    transform: "translate(-39.02 -33.663)",
    fill: "#2bc7c9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.f25b60c4470b89e8f2d325ef7d4ac088.svg";
export { ForwardRef as ReactComponent };